export default [
  {
    path: "/activity",
    name: "activity",
    component: () => import("@/page/activity/index.vue"),
    meta: {
      title: "活动"
    },
    children: [
      {
        path: "/activity",
        name: "activity-index",
        component: () => import("@/page/activity/index/index.vue"),
        meta: {
          title: "活动",
        }
      },
      {
        path: "category",
        name: "category-list",
        component: () => import("@/page/activity/category-list/index.vue")
      },
      {
        path: "details",
        name: "activity-details",
        component: () => import("@/page/activity/activity-details/index.vue"),
        meta: {
          title: "活动详情",
          keepAlive: true
        }
      },
      {
        path: "order",
        name: "my-activity",
        component: () => import("@/page/activity/my-activity/index.vue"),
        meta: {
          title: "我的活动",
        }
      },
      {
        path: "ticketDetails",
        name: "ticket-details",
        component: () => import("@/page/activity/ticket-details/index.vue"),
        meta: {
          title: "详情"
        }
      },
      {
        path: "signup",
        name: "activity-signup",
        component: () => import("@/page/activity/signup/index.vue"),
        meta: {
          title: "提交订单",
          keepAlive: true
        }
      },
      {
        path: "payment/detail",
        name: "activity-payment-details",
        component: () => import("@/page/activity/payment-details/index.vue"),
        meta: {
          title: "订单详情"
        }
      },
      {
        path: "payment/success",
        name: "activity-payment-success",
        component: () => import("@/page/activity/payment-details/success.vue"),
        meta: {
          title: "订单详情",
          keepAlive: true
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/activity.js